/* eslint-disable no-unused-expressions,no-unused-vars */
/* global PLATFORM, G */
import map from 'lib/sequence/model/api/map'
import { asyncPipeSpread, asyncPipeSpreadIf, bulk } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { hide, show } from 'lib/sequence/component/state/hidden'
import { set } from 'lib/sequence/component/state/value'
import sequenceComponentState from 'lib/sequence/component/state'
import { checked, uncheck } from 'lib/sequence/component/state/checked'
import search from 'app/_shared/events/search'
import listLocationValues from 'app/_shared/events/collection/listLocationValues'
import { computeTickValues, linspace, mean, scale, standardDeviation } from 'app/xEcoApm/helper'
import listTemperatureUnits from 'app/xEcoApm/event/collection/listTemperatureUnits'

/**
 * @typedef {Record<string, Gaia.Component.Spec|null>} Components
 */

// const referenceData = {
//   rawdata:{
//     frequency:[831,878,1131,1207,1188,1074,1344,1333,1448,1284,1197,1374,1472,1286,1305,1264,1758,1766,1573,1255,1714,2010,1663,1637,1742,1813,2154,2047,1676,1955,2147,2248,2148,2168,2280,2598,2133,2060,2154,2183,2616,2295,2291,2257,2226,2155,2101,2221,2081,1968,1801,1921,2195,2290,1838,2026,1672,1876,1691,1834,1749,1527,1484,1651,1510,1526,1350,1485,1260,1324,1278,1313,1339,1314,1224,1226,1490,1354,1094,1126,958,1121,1189,1017,1078,993,1155,1155,990,1078,1046,1149,946,921,949,972,1019,1006,952,923,1028,1034,903,838,840,933,748,949,958,902,899,852,800,848,908,790,745,778,784,780,835,738,827,846,684,744,650,844,753,690,709,744,770,746,672,632,641,773,769,636,694,649,690,721,656,598,708,618,617,577,663,606,635,653,645,738,681,684,692,672,654,693,718,627,627,705,683,662,664,732,744,759,756,769,919,815,807,720,836,861,810,865,918,845,893,736,857,863,919,877,753,881,905,966,812,722,982,798,870,896,778,918,884,834,767,826,960,928,933,900,825,827,836,789,776,976,938,866,968,927,961,796,860,818,891,743,855,766,816,891,818,906,780,912,805,833,840,808,849,876,796,772,751,890,757,746,845,995,1053,855,912,806,860,947,1048,912,1066,822,1074,886,922,1059,859,914,1025,981,1154,1291,987,974,1265,1178,1266,1393,1377,1206,1310,1142,1381,1447,1426,1484,1498,1555,1791,1685,1671,1818,1528,1519,2096,1959,1542,2215,2033,2117,1956,2372,3293,2523,2200,2076,2234,3299,2832,2607,2181,2818,3956,3062,2917,3570,5816,9415,11024,18184,15789,14821,18035,15562,12733,22893,16073,22607,33059.0016,35080,36168,33575.0016,38876,37332,16728,36520.9984,62505.9968,30934,21654,46802,48548,74804.9984,33772,39788.9984,39016,30768,46092,60448,23716,29183.0016,42796,40756,44380.9984,21227,17330,53320.9984,17207,27670,21934,28896.9984,37123.0016,30244,27932,16770,20468,16366,19159,14352,12560,8658,8594,6294,6066,5643,4110,2545,3481,2651,3722,2709,2752,1974,1610,1506,1567,1602,1984,1814,4295,3059,5938,3436,3114,2342,1737,1536,2336,1561,1564,1274,1166,1528,1224,1268,1147,1076,1277,906,1170,1352,1138,1398,1211,1232,912,925,924,847,954,919,906,828,751,984,860,876,718,890,864,884,780,803,839,1089,757,727,751,836,768,816,789,737,773,671,790,853,807,723,851,704,760,731,714,720,716,798,827,777,636,770,760,754,624,716,836,750,768,703,776,722,687,695,705,787,724,717,625,646,685,706,727,686,631,750,714,725,679,633,743,695,624,614,755,703,635,634,659,584,725,671,606,661,639,560,646,711,711,585,608,646,653,627,599,598,635,639,679,667,610,601,598,698,561,572,694,597,546,642,532,598,610,562,595,611,645,631,547,645,551,582,622,568,634,487,610,584,587,611,563,578,576,603,530,569,512,600,581,548,557,602,488,606,620,564,625,663,572,554,637,608,589,592,518,587,580,596,528,629,679,586,644,589,648,666,657,605,649,616,640,640,660,720,668,726,720,735,678,776,835,796,752,793,927,976,829,904,933,862,869,886,937,998,1027,974,1061,1011,1086,1060,1068,944,999,920,1145,1198,1057,966,1006,1113,878,882,926,928,993,896,987,1000,889,877,845,893,852,924,732,804,772,800,790,741,751,710,714,731,619,653,739,654,729,615,627,641,638,607,605,646,566,501,563,526,625,485,460,582,543,574,498,533,523,483,535,512,566,520,435,513,462,462,453,513,474,449,488,507,473,538,515,463,413,526,477,492,445,472,455,486,433,475,472,455,428,507,480,508,450,436,472,427,393,430,404,438,439,420,473,530,483,456,458,466,425,426,413,439,444,444,427,450,437,410,430,389,365,433,409,391,442,469,429,447,431,394,412,465,462,421,376,461,433,404,468,474,450,439,468,387,422,482,433,479,432,458,423,464,425,464,469,448,506,503,434,512,501,433,437,544,519,417,393,462,485,458,380,520,471,407,441,484,490,473,513,385,466,500,438,451,425,498,457,506,480,459,493,411,444,486,449,563,500,430,479,425,468,468,472,486,463,503,493,498,592,525,491,595,403,500,515,543,526,537,565,573,520,580,537,532,639,509,569,555,458,566,597,461,550,638,633,662,591,547,593,656,532,613,679,601,575,596,650,578,582,753,559,627,664,596,624,677,809,774,633,856,858,837,866,794,837,854,806,841,756,890,1106,974,876,894,978,1280,1280,1045,1212,1600,1328,902,969,1182,1079,1363,1193,1146,1097,1278,1217,1332,1133,957,1261,1093,1006,1143,1025,808,877,1197,1056,1229,756,696,843,1088,1045,791,1058,1242,673,875,667,729,547,572,687,541,578,639,565,559,503,430,493,535,469,457,420,521,394,419,458,462,432,354,418,401,374,320,391,317,370,341,401,379,334,347,297,292,349,297,278,299,311,315,341,283,324,300,282,284,258,279,262,250,282,263,303,288,307,253,265,293,238,237,237,242,268,280,270,290,280,300,320,310,350,340,400,380,460,430,520,480,580,540,600,580,640,600,680,660,740,720,800,780].map(i => i * 10),
//     cavitation:[686,688,689,690,691,692,694,695,696,697,698,699,700,701,702,703,704,705,706,706,707,708,709,710,710,711,712,713,713,714,714,715,716,716,717,717,718,718,719,719,720,720,720,721,721,721,722,722,722,722,723,723,723,723,723,723,723,723,723,724,724,724,723,723,723,723,723,723,723,723,723,723,722,722,722,722,721,721,721,720,720,720,719,719,719,718,718,717,717,716,716,715,715,714,714,713,713,712,712,711,710,710,709,709,708,707,706,706,705,704,704,703,702,702,701,700,699,698,698,697,696,695,694,694,693,692,691,690,690,689,688,687,686,685,684,684,683,682,681,680,679,679,678,677,676,676,675,675,675,674,674,674,675,675,676,677,677,678,680,681,682,684,686,687,689,691,693,694,696,698,700,702,704,706,708,710,712,714,716,718,720,722,724,726,728,730,732,734,736,738,740,742,744,746,748,750,752,755,757,759,761,763,765,767,769,771,774,776,778,780,782,785,787,789,791,794,796,798,801,803,806,808,810,813,815,818,820,823,825,828,830,833,836,838,841,844,846,849,852,855,858,860,863,866,869,872,875,878,881,884,887,890,893,896,899,902,905,908,910,913,916,919,922,925,927,930,933,936,938,941,944,946,948,951,954,956,959,961,963,966,968,971,972,975,977,979,981,984,985,988,989,992,993,996,997,999,1000,1003,1004,1006,1007,1009,1010,1012,1013,1015,1016,1018,1018,1020,1020,1022,1023,1024,1024,1026,1026,1028,1028,1029,1029,1031,1030,1032,1031,1032,1032,1033,1032,1034,1033,1034,1033,1034,1033,1034,1032,1033,1032,1032,1031,1032,1030,1031,1029,1029,1028,1028,1026,1026,1024,1024,1022,1022,1020,1020,1018,1017,1015,1014,1012,1012,1009,1008,1006,1005,1003,1002,999,998,995,994,991,990,987,986,983,981,978,977,974,972,969,967,964,962,959,957,954,951,948,946,943,940,937,935,931,929,925,923,920,917,913,911,907,904,901,898,894,891,888,885,881,878,874,871,867,864,861,857,854,850,847,843,840,836,833,829,825,822,818,815,811,808,804,801,797,794,791,787,784,781,778,775,772,769,766,763,761,758,756,753,751,748,746,743,741,738,736,734,731,729,726,724,722,719,717,715,712,710,708,705,703,701,698,696,694,692,690,687,685,683,681,679,677,675,673,671,668,666,664,662,660,658,656,655,653,651,649,647,645,643,642,640,638,636,635,633,631,630,628,626,625,623,621,620,618,617,615,614,612,610,609,607,606,604,603,602,600,599,597,596,595,593,592,591,590,589,588,586,585,584,583,583,582,581,580,579,578,578,577,576,575,575,574,573,573,572,571,571,570,569,568,568,567,566,566,565,564,564,563,562,562,561,560,559,559,558,557,557,556,555,555,554,553,552,552,551,550,550,549,548,548,547,546,545,545,544,543,542,542,541,540,540,539,538,537,537,536,535,534,534,533,532,531,531,530,529,528,528,527,526,525,525,524,523,522,522,521,520,519,518,518,517,516,515,514,514,513,512,511,510,510,509,508,507,506,506,505,504,503,502,502,501,500,499,498,497,497,496,495,494,493,492,491,491,490,489,488,487,486,486,485,484,483,482,481,480,479,479,478,477,476,475,474,473,473,472,471,470,469,468,467,466,465,465,464,463,462,461,460,459,458,457,457,456,455,454,453,452,451,450,449,448,448,447,446,445,444,443,442,441,440,440,439,438,437,436,435,435,434,433,433,432,431,431,431,430,430,430,429,429,429,429,429,429,429,429,429,429,429,429,429,430,430,430,430,430,430,430,430,430,430,430,430,430,430,430,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,431,430,430,430,430,430,430,430,430,430,430,430,430,429,429,429,429,429,429,428,428,428,428,428,428,427,427,427,427,426,426,426,426,425,425,425,425,424,424,424,423,423,423,422,422,422,421,421,421,420,420,419,419,418,418,417,417,416,416,415,415,414,414,413,413,412,412,411,411,410,410,409,408,408,407,406,406,405,404,404,403,402,402,401,400,399,399,398,397,396,396,395,394,393,392,391,391,390,389,388,387,386,385,384,384,383,382,381,380,379,378,377,376,375,374,373,372,371,370,369,368,367,366,365,364,363,361,360,359,358,357,356,355,354,352,351,350,349,348,346,345,344,343,342,340,339,338,337,335,334,333,332,330,329,328,326,325,324,323,321,320,319,317,316,315,313,312,310,309,308,306,305,304,302,301,299,298,297,295,294,292,291,290,288,287,285,284,283,281,280,278,277,275,274,273,271,270,268,267,266,264,263,262,260,259,258,257,256,254,253,252,252,251,250,249,248,248,247,246,246,245,245,244,244,243,243,242,242,242,241,241,241].map(i => i * Math.random() * 1000)
//   },
//   results:{
//     frequency:[51001,52002,51003,52004,51005,52006,51007,52008,51009,52010,51011,52012,51013,52014,51015,52001,51002,52003,51004,52005,51006,52007,51008,52009,51010,52011,51012,52013,51014,52015,51508].map(i => i * Math.random() * 1000),
//     time:[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],
//     apm:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0].map(i => Math.random() * 1000),
//   },
// }

const {
  set: decorate,
} = sequenceComponentState('decorators')

/**
 * @typedef {Record<string, Gaia.Component.Spec|null>} Components
 */

const bulkHide = bulk(hide)
const bulkShow = bulk(show)

const MAX_FREQUENCY = 192000 // Hz
const ORIGINAL_VIEWPORT_X = [10000, 155000]

const acousticSpectrumXBounds = {
  min: 10000,
  max: 150000,
}

let referenceCache = null

const getCachedReferenceData = module => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const measurementValues = measurement[G.DATA].project
    ? measurement[G.DATA] || {}
    : measurement[G.CACHE].value || {}
  const { project, tank, location, frequency, usPower } = measurementValues

  const dataKey = { project, tank, location, frequency, usPower, reference: true }
  const [keys, value] = referenceCache || []

  return keys && Object.keys(dataKey).every(key => dataKey[key] === keys[key])
    ? value
    : null
}

const setCachedReferenceData = (module, data) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const measurementValues = measurement[G.DATA].project
    ? measurement[G.DATA] || {}
    : measurement[G.CACHE].value || {}
  const { project, tank, location, frequency, usPower } = measurementValues

  const dataKey = { project, tank, location, frequency, usPower, reference: true }
  referenceCache = [dataKey, data]
}

/**
 * Sets the `component`'s state properties from `stateObject`.
 *
 * @param {Gaia.Component.Spec} component   component to set the state for
 * @param {object} stateObject object containing states to set
 */
const setState = (component, stateObject) => {
  Object.keys(stateObject).forEach((key) => {
    component[G.STATE][key] = stateObject[key]
  }, {})
}

/**
 * Checks whether the `showReference` checkbox is checked.
 *
 * @param {Components} components {@link find} proxy of the current action component
 * @returns {boolean}
 */
export const shouldShowReference = (components) => {
  const { showReference } = components
  return checked(showReference)
}

/**
 * Attempts to find the measurement that should be used as a reference and compared with the current
 * one. That is, the latest measurement with the same values for `project`, `tank`, `location`,
 * `frequency` and `usPower` as the current measurement and with its `reference` value set to
 * `true`.
 *
 * A measurement marked as `reference` should not be compared and thus, if that is the case for the
 * current measurement, this function short-circuits and returns `null`. Calling it with
 * `force: true` overrides this behavior.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @param {Object} options              object to force using specific options explicit
 * @param {boolean} options.force       if true, attempts to find a reference even if the current
 *                                      measurement is also a reference
 * @return {Promise<*|null>}
 */
export const searchReferenceMeasurement = async (module, { force } = {}) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const measurementValues = measurement[G.DATA].project
    ? measurement[G.DATA] || {}
    : measurement[G.CACHE].value || {}

  const { project, tank, location, frequency, usPower, reference } = measurementValues

  if (reference && !force) {
    return null
  }

  const filter = { project, tank, location, frequency, usPower, reference: true }
  const type = 'x_eco_apmmeasurement'
  const sort = [["submit_timestamp<number>", "desc"]]
  const options = { type, filter, sort }

  const measurements = await search(null, module, null, options)
  return measurements.find(item => item.key !== measurement[G.STATE][G.REF])
}

/**
 * Sets the section title.
 *
 * @param module  current module
 * @returns {(function(*, ...[*]): Promise<*>)|*}
 */
const setTitle = module => async (components, ...args) => {
  const { measurement: model } = module[G.MODEL][G.CHILDREN]
  const { item, project } = model[G.CHILDREN]
  const { name } = item[G.CHILDREN]
  const { title } = components

  const value = name[G.CACHE]
    ? `${name[G.CACHE]} ${project[G.CACHE]}`
    : project[G.CACHE]

  set(title, value)

  return [components, ...args]
}

/**
 * Presets the device's location
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
export const mapProperties = module => async (components, ...args) => {
  // model
  const { measurement: model } = module[G.MODEL][G.CHILDREN]
  const bulkMap = bulk(map(model))

  if (PLATFORM === 'mobile') {
    const { info, details, commentContainer } = components
    bulkMap(info, details, commentContainer)
  }

  if (PLATFORM === 'web') {
    const { submitter } = model[G.CHILDREN]
    const { firstName, lastName, name } = submitter[G.CHILDREN].person?.[G.CACHE]?.[0]?.value || {}
    const { measurementInfo, details, createdBy } = components

    bulkMap(measurementInfo, details, createdBy)

    const fullName = (firstName && lastName && `${firstName} ${lastName}`)
      || name
      || '-'

    const { name: nameComponent } = find(createdBy)
    set(nameComponent, fullName)
  }

  return [components, ...args]
}

/**
 * Sets quantities for the fields that need them.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(*, ...[*]): Promise<[Components, ...[*]]>}
 */
export const mapQuantities = module => async (components, ...args) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const cache = measurement[G.CACHE]?.value
  const { frequency, usPower, temperature } = components

  if (cache) {
    const [unit] = listTemperatureUnits(module, components.component, cache.temperatureUnit)

    cache.frequency
    && set(frequency, `${cache.frequency} kHz`)

    cache.usPower
    && set(usPower, `${cache.usPower} %`)

    cache.temperature
    && set(temperature, `${cache.temperature} ${unit?.value ?? ''}`)
  }

  return [components, ...args]
}

/**
 * Translates and sets the location value.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(Components, ...[*]): Promise<[Components, ...[*]]>}
 */
export const mapLocation = module => async (components, ...args) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const { location } = components
  const cache = measurement[G.CACHE]?.value

  const [locationItem] = listLocationValues(module, components.component, cache.location)

  set(location, locationItem?.value ?? '')

  return [components, ...args]
}

/**
 * Presets the device's location
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(Components, ...[*]): Promise<[Components, ...[*]]>}
 */
export const displayReferenceBadge = module => async (components, ...args) => {
  // model
  const { measurement: model } = module[G.MODEL][G.CHILDREN]
  const { reference } = model[G.CHILDREN]

  const { referenceMeasurement } = components

  reference[G.CACHE]
    ? show(referenceMeasurement)
    : hide(referenceMeasurement)

  return [components, ...args]
}

/**
 * Attempts to find a reference measurement against which to compare the current one, if it's not
 * marked as a reference. Adds the found reference as the second item of the `args` array.
 *
 * The reference measurement to be looked for has the same values for the `project`, `tank`,
 * `location`, `frequency` and `usPower` properties as the current one and its `reference` property
 * is `true`.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(Components, ...[*]): Promise<[Components, object, ...[*]]>}
 */
export const loadReferenceMeasurementData = module => async (components, ...args) => {
  const referenceData = getCachedReferenceData(module)

  if (referenceData) {
    return [components, referenceData, ...args]
  }

  try {
    const reference = await searchReferenceMeasurement(module)
    const measuredDataString = reference?.value?.measuredData
    const measuredData = JSON.parse(measuredDataString)

    setCachedReferenceData(module, measuredData)
    return [components, measuredData, ...args]
  } catch (error) {
    console.warn('Reference data could not be obtained or parsed', error)
    return [components, null, ...args]
  }
}

/**
 * Adds `measurementData` from the `measurement` model to the second position of the `args` array.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(Components, ...[*]): Promise<[Components, object, ...[*]]>}
 */
export const loadMeasurementData = module => async (components, ...args) => {
  const model = module[G.MODEL]
  const { measurement } = model[G.CHILDREN]
  const { measuredData } = measurement[G.CHILDREN]

  const data = measuredData[G.CACHE]
    ? JSON.parse(measuredData[G.CACHE])
    : {}

  return [components, data, ...args]
}

/**
 * Toggles the display of the `showReference` checkbox according to the current data.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(Components, ...[*]): Promise<[Components, object, ...[*]]>}
 */
export const displayReferenceToggle = module => async (components, data, referenceData, ...args) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const { reference } = measurement[G.CACHE].value || {}
  const { showReference } = components

  if (showReference && (reference || (checked(showReference) && !referenceData))) {
    uncheck(showReference)
    hide(showReference)
  }

  return [components, data, referenceData, ...args]
}

/**
 * Toggles the display of values related to the reference measurement depending on whether
 * `referenceData` is defined.
 *
 * @param {Components} components {@link find} proxy of the current action component
 * @param {object} data                        data of the current measurement
 * @param {object} referenceData               data of the reference measurement (if any)
 * @param {unknown[]} args                     additional arguments
 * @returns {Promise<[Components, object, object, unknown[]]>}
 */
export const displayReferenceValues = async (components, data, referenceData, ...args) => {

  const {
    avgFrequencyRef,
    avgUltrasonicIntensityRefSd,
    avgUltrasonicIntensityRef
  } = components

  const bulkDisplay = referenceData
    ? bulkShow
    : bulkHide

  bulkDisplay(
    avgFrequencyRef,
    avgUltrasonicIntensityRef,
    avgUltrasonicIntensityRefSd,
  )

  return [components, data, referenceData, ...args]
}

/**
 * Calculates and displays the average ultrasonic intensity according to `data`.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(Components, object, object, ...[*]): Promise<[Components, object, object, ...[*]]>}
 */
export const displayAvgUltrasonicIntensity = module => async (components, data, referenceData, ...args) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const cache = measurement[G.CACHE]?.value

  const { avgUltrasonicIntensity, avgUltrasonicIntensitySd } = components
  const { avgUltrasonicIntensityRef, avgUltrasonicIntensityRefSd } = components

  const apmAll = data?.results?.apm ?? []
  const apm = apmAll.length ? apmAll.slice(0, -1) : []
  const meanApm = parseFloat(mean(apm).toFixed(1))
  const stdApm = parseFloat(standardDeviation(apm).toFixed(1))
  set(avgUltrasonicIntensity, `${meanApm} Pa`)
  set(avgUltrasonicIntensitySd, `${stdApm} Pa`)

  // According to the specs: If the SD is greater than X % of the average
  // ultrasound intensity, it should be colored red, otherwise green
  stdApm > (meanApm * (cache.usPower / 100))
    ? decorate(avgUltrasonicIntensitySd, { value: { error: true } })
    : decorate(avgUltrasonicIntensitySd, { value: { success: true } })

  if (referenceData) {
    const apmAllRef = referenceData?.results?.apm ?? []
    const apmRef = apmAllRef.length ? apmAllRef.slice(0, -1) : []
    const meanApmRef = mean(apmRef).toFixed(1)
    const stdApmRef = standardDeviation(apmRef).toFixed(1)
    set(avgUltrasonicIntensityRef, `${meanApmRef} Pa`)
    set(avgUltrasonicIntensityRefSd, `${stdApmRef} Pa`)
  }

  return [components, data, referenceData, ...args]
}

/**
 * Calculates and displays the average frequency according to `data`.
 *
 * @param {Components} components {@link find} proxy of the current action component
 * @param {object} data                        data of the current measurement
 * @param {object} referenceData               data of the reference measurement (if any)
 * @param {unknown[]} args                     additional arguments
 * @returns {Promise<[Components, object, object, ...[*]]>}
 */
export const displayAvgFrequency = async (components, data, referenceData, ...args) => {
  const { avgFrequency, avgFrequencyRef } = components

  const freqAll = data?.results?.frequency ?? []
  const freq = freqAll.length ? freqAll.slice(0, -1) : []
  const meanFreq = scale(mean(freq), 1000).toFixed(1)
  set(avgFrequency, `${meanFreq} kHz`)

  if (referenceData) {
    const freqAllRef = referenceData?.results?.frequency ?? []
    const freqRef = freqAllRef.length ? freqAllRef.slice(0, -1) : []
    const meanFreqRef = scale(mean(freqRef), 1000).toFixed(1)
    set(avgFrequencyRef, `${meanFreqRef} kHz`)
  }

  return [components, data, referenceData, ...args]
}

/**
 * Toggles the display of the comment section depending on whether the model's `comment` attribute
 * has a value.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(Components, ...[*]): Promise<[Components, ...[*]]>}
 */
export const displayComment = module => async (components, ...args) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const { comment } = measurement[G.CHILDREN]
  const { commentLabel, commentContainer } = components

  comment[G.CACHE]
    ? bulkShow(commentLabel, commentContainer)
    : bulkHide(commentLabel, commentContainer)

  return [components, ...args]
}

/**
 * Uses `data` to derive and set the values of the action's acoustic spectrum chart element.
 *
 * @param {Components} components {@link find} proxy of the current action component
 * @param {object} data                        data of the current measurement
 * @param {object} referenceData               data of the reference measurement (if any)
 * @param {unknown[]} args                     additional arguments
 * @returns {Promise<[Components, object, object, ...[*]]>}
 */
export const renderAcousticSpectrumChart = async (components, data, referenceData, ...args) => {
  const { acousticSpectrumChart } = components

  const frequency = data?.rawdata?.frequency
  const numPoints = frequency?.length ?? 0

  const xFrequencyHz = linspace(0, MAX_FREQUENCY, numPoints)

  let acousticSpectrum = xFrequencyHz
    .map((freq, index) => {
      const ampl = data?.rawdata?.frequency?.[index] ?? 0
      const cavi = data?.rawdata?.cavitation?.[index] ?? 0
      const amplRef = referenceData?.rawdata?.frequency?.[index]
      return {
        frequency: freq,
        amplitude: ampl,
        amplitudeLog: Math.log10(ampl),
        cavitationLog: Math.log10(cavi),
        ...referenceData && {
          amplitudeRef: amplRef,
          amplitudeLogRef: Math.log10(amplRef),
        }
      }
    })
    // As per spec, anything outside 10k and 140k is ignored
    .filter(({frequency}) => frequency >= acousticSpectrumXBounds.min && frequency <= acousticSpectrumXBounds.max)

  const max = Math.floor(Math.max(...acousticSpectrum.filter(p => isFinite(p.amplitudeLog)).map(p => Math.max(p.amplitudeLog, p.cavitationLog, p.amplitudeLogRef || 0)))) + 1
  const min = Math.ceil(Math.min(...acousticSpectrum.filter(p => isFinite(p.cavitationLog)).map(p => Math.min(p.amplitudeLog, p.cavitationLog, p.amplitudeLogRef || Number.MAX_SAFE_INTEGER)))) - 1

  const firstNonZeroAmpLog = acousticSpectrum.find(p => isFinite(p.amplitudeLog))?.amplitudeLog ?? min
  const firstNonZeroCaviLog = acousticSpectrum.find(p => isFinite(p.cavitationLog))?.cavitationLog ?? min
  const firstNonZeroAmpLogRef = acousticSpectrum.find(p => isFinite(p.amplitudeLogRef))?.amplitudeLogRef ?? min

  acousticSpectrum = acousticSpectrum.reduce((acc, p, index) => {
    const previous = acc[index - 1]
    const previousAmp = index === 0 ? firstNonZeroAmpLog : previous.amplitudeLog
    const previousCavi = index === 0 ? firstNonZeroCaviLog : previous.cavitationLog
    const previousAmpRef = index === 0 ? firstNonZeroAmpLogRef : previous.amplitudeLogRef

    return [
      ...acc,
      {
        frequency: p.frequency,
        amplitude: p.amplitude,
        amplitudeLog: isFinite(p.amplitudeLog) ? p.amplitudeLog : previousAmp,
        ...referenceData && {
          amplitudeLogRef: isFinite(p.amplitudeLogRef) ? p.amplitudeLogRef: previousAmpRef,
        },
        cavitationLog: isFinite(p.cavitationLog) ? p.cavitationLog : previousCavi,
      }
    ];
  }, [])

  const spectrumTickValues = computeTickValues(ORIGINAL_VIEWPORT_X[0], ORIGINAL_VIEWPORT_X[1])

  setState(acousticSpectrumChart, {
    data: acousticSpectrum,
    yDomain: [min, max],
    xTickValues: spectrumTickValues,
    xTickCount: spectrumTickValues.length,
    yTickCount: max - min + 1,
  })

  return [components, data, referenceData, ...args]
}

/**
 * Uses `data` to derive and set the values of the action's cavitation intensity chart element.
 *
 * @param {Components} components {@link find} proxy of the current action component
 * @param {object} data                        data of the current measurement
 * @param {object} referenceData               data of the reference measurement (if any)
 * @param {unknown[]} args                     additional arguments
 * @returns {Promise<[Components, object, object, ...[*]]>}
 */
export const renderCavitationIntensityChart = async (components, data, referenceData, ...args) => {
  const { cavitationIntensityChart } = components
  const { cavitationIntensityPassedLabel, cavitationIntensityNotPassedLabel } = components

  const timeAll = data?.results?.time ?? []
  const apmAll = data?.results?.apm ?? []
  const apmRefAll = referenceData?.results?.apm ?? []

  const time = timeAll.length ? timeAll.slice(0, -1) : []
  const apm = apmAll.length ? apmAll.slice(0, -1) : []
  const apmMean = mean(apm)

  const apmRef = apmRefAll.length ? apmRefAll.slice(0, -1) : []
  const apmMeanRef = mean(apmRef)
  const apmMeanRefMargin = (apmMeanRef * 0.20)
  const apmMeanRefUpper = apmMeanRef + apmMeanRefMargin
  const apmMeanRefLower = apmMeanRef - apmMeanRefMargin

  // smooth apm using factor with 0.3 for previous point and 0.7 for current point
  const points = time.map((t, i) => ({
    time: Number(t),
    apm: Number(i > 0 ? (apm[i - 1] * 0.3 + apm[i] * 0.7) : apm[i]),
    ...referenceData && {
      apmRef: apmMeanRef,
      apmRefUpper: apmMeanRefUpper,
      apmRefLower: apmMeanRefLower,
    },
  }))

  if (referenceData) {
    apmMean > apmMeanRefUpper || apmMean < apmMeanRefLower
      ? show(cavitationIntensityNotPassedLabel)
      : show(cavitationIntensityPassedLabel)
  } else {
    bulkHide(
      cavitationIntensityPassedLabel,
      cavitationIntensityNotPassedLabel,
    )
  }

  const maxValue = Math.max(...points.map(p => p.apm))
  const minValue = Math.min(...points.map(p => p.apm))
  const min = 0
  const max = Math.max(maxValue, apmMeanRefUpper) * 1.2

  setState(cavitationIntensityChart, {
    data: points,
    yDomain: [min, max],
    // yTickValues: Array.from({ length: 5 }, (_, i) => min + i * (max - min) / 4),
    yTickCount: 10,
    hideLegend: !referenceData,
  })

  return [components, data, referenceData, ...args]
}

/**
 * Uses `data` to derive and set the values of the action's frequency intensity chart element.
 *
 * @param {Components} components {@link find} proxy of the current action component
 * @param {object} data                        data of the current measurement
 * @param {object} referenceData               data of the reference measurement (if any)
 * @param {unknown[]} args                     additional arguments
 * @returns {Promise<[Components, object, object, ...[*]]>}
 */
export const renderMainFrequencyChart = async (components, data, referenceData, ...args) => {
  const { mainFrequencyChart } = components
  const { mainFrequencyPassedLabel, mainFrequencyNotPassedLabel } = components

  const timeAll = data?.results?.time ?? []
  const freqAll = data?.results?.frequency ?? []

  const freqRefAll = referenceData?.results?.frequency ?? []
  const freqRef = freqRefAll.length ? freqRefAll.slice(0, -1) : []

  const time = timeAll.length ? timeAll.slice(0, -1) : []
  const freq = freqAll.length ? freqAll.slice(0, -1) : []
  const freqMean = mean(freq)

  const freqMeanRef = mean(freqRef)
  const freqMeanRefMargin = 5000
  const freqMeanRefUpper = freqMeanRef + freqMeanRefMargin
  const freqMeanRefLower = freqMeanRef - freqMeanRefMargin

  const points = time.map((t, i) => ({
    time: Number(t),
    freq: Number(freq[i]),
    ...referenceData && {
      freqRef: freqMeanRef,
      freqRefUpper: freqMeanRefUpper,
      freqRefLower: freqMeanRefLower,
    },
  }))

  if (referenceData) {
    freqMean > freqMeanRefUpper || freqMean < freqMeanRefLower
      ? show(mainFrequencyNotPassedLabel)
      : show(mainFrequencyPassedLabel)
  } else {
    bulkHide(
      mainFrequencyPassedLabel,
      mainFrequencyNotPassedLabel,
    )
  }

  const maxValue = Math.max(...points.map(p => p.freq))
  const minValue = Math.min(...points.map(p => p.freq))
  const padding = 10000
  const min = Math.min(minValue, freqMeanRefLower) - padding
  const max = Math.max(maxValue, freqMeanRefUpper) + padding

  setState(mainFrequencyChart, {
    data: points,
    yDomain: [min, max],
    yTickCount: 10,
    hideLegend: !referenceData,
  })

  return [components, data, referenceData, ...args]
}

/**
 * Closes the pipe by only returning the `args` parameter.
 *
 * @param {Components} components {@link find} proxy of the current action component
 * @param {object} data                        data of the current measurement
 * @param {object} referenceData               data of the reference measurement (if any)
 * @param {unknown[]} args                     additional arguments
 * @returns {unknown[]}                         the additional arguments
 */
export const returnArgs = async (components, data, referenceData, ...args) => args

/**
 * Measurement Detail Action
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  mapProperties(module),
  mapQuantities(module),
  mapLocation(module),
  displayComment(module),
  displayReferenceBadge(module),
  asyncPipeSpreadIf((...args) => PLATFORM === 'mobile' && shouldShowReference(...args))(
    loadReferenceMeasurementData(module),
  ),
  loadMeasurementData(module),
  displayReferenceToggle(module),
  displayReferenceValues,
  asyncPipeSpreadIf(() => PLATFORM === 'mobile')(
    setTitle(module),
    renderAcousticSpectrumChart,
    renderCavitationIntensityChart,
    renderMainFrequencyChart,
    displayAvgUltrasonicIntensity(module),
    displayAvgFrequency,
  ),
  returnArgs,
)(find(component), ...args)
